export const productTypes = [
  { id: 'All', description: 'Todos' },
  { id: 'ACESSORIO', description: 'ACESSORIO' },
  { id: 'ANEL', description: 'ANEL' },
  { id: 'CAMERA', description: 'CAMERA' },
  { id: 'FONE DE OUVIDO', description: 'FONE DE OUVIDO' },
  { id: 'MONITOR', description: 'MONITOR' },
  { id: 'NOTEBOOK', description: 'NOTEBOOK' },
  { id: 'ÓCULOS 3D', description: 'ÓCULOS 3D' },
  { id: 'RELÓGIO', description: 'RELÓGIO' },
  { id: 'TABLET', description: 'TABLET' },
  { id: 'TELEFONE MOVEL CELULAR', description: 'TELEFONE MOVEL CELULAR' },
];
